// src/components/RichText/RichTextField.js
import React, { useState, useEffect } from 'react'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import RichTextEditor from './RichTextEditor'
import RichTextPreview from './RichTextPreview'

const RichTextField = ({
	value,
	onChange,
	label
}) => {
	const [activeTab, setActiveTab] = useState('editar')
	const [rawState, setRawState] = useState('')

	useEffect(() => {
		if (rawState) {
			onChange(JSON.stringify(rawState))
		}
	}, [rawState])

	return (
		<div>
			{label && <div className="mb-2">{label}</div>}
			<Tabs
				activeKey={activeTab}
				onSelect={(k) => setActiveTab(k)}
				className="mb-3"
			>
				<Tab eventKey="editar" title={<><i className="fa fa-pencil"></i> Editar</>}>
					<RichTextEditor
						setHTML={setRawState}
						existingHTML={value}
						setRawState={setRawState}
						existingRawState={value}
					/>
				</Tab>
				<Tab eventKey="previsualizar" title={<><i className="fa fa-eye"></i> Previsualizar</>}>
					<RichTextPreview rawContent={rawState} />
				</Tab>
			</Tabs>
		</div>
	)
}

export default RichTextField